import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v18h22V3zm-2 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z"
}), 'PresentToAllSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PresentToAllSharp.js
// module id = 5605
// module chunks = 2